import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { APP_ROUTE_NAMES } from '@app/app.routes'

import { ContactPhoneComponent } from '../contact-info/phone/contact-phone.component'
import { RouterLink } from '@angular/router'
import { MatToolbarModule } from '@angular/material/toolbar'
import { DOMAIN_NAME, PROJECT } from '@app/tokens'
import { LogoComponent } from '@features/logo/logo.component'
import { ENV, ProjectName } from '@app/env-registry'

type Link = {
  title: string
  path: string
}
type Item = { section: string; links: ReadonlyArray<Link> }

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatToolbarModule, RouterLink, ContactPhoneComponent, LogoComponent]
})
export class FooterComponent {
  readonly domain = inject(DOMAIN_NAME)
  readonly project = inject(PROJECT)
  readonly companyRegistrationNumber = inject(ENV).companyRegistrationNumber

  readonly appYear = (() => {
    switch (this.project) {
      case ProjectName.FINEA:
        return '2022'

      case ProjectName.DALIDALI:
        return '2024'

      case ProjectName.MINIBANK:
        return '2026'
    }
  })()


  readonly items: Item[] = [
    {
      section: this.project === 'minibank'
        ? $localize`:footer-section|company section title@@footer-company-minibank:Company`
        : $localize`:footer-section|company section title@@footer-company:Company`,
      links: [
        { title: $localize `:footer-section-item|company section item:About us`, path: `/${APP_ROUTE_NAMES.FOOTER_ABOUT}` },
        { title: $localize `:footer-section-item|company section item:License`, path: `/${APP_ROUTE_NAMES.FOOTER_LICENSE}` },
        { title: $localize `:footer-section-item|company section item:Contacts`, path: `/${APP_ROUTE_NAMES.FOOTER_CONTACTS}` },
      ]
    },
    {
      section: $localize `:footer-section|document section title:Documents`,
      links: [
        { title: $localize `:footer-section-item|document section item:Pricing`, path: `/${APP_ROUTE_NAMES.FOOTER_PRICING}` },
        { title: $localize `:footer-section-item|document section item:Agreement`, path: `/${APP_ROUTE_NAMES.FOOTER_AGREEMENT}` },
        { title: $localize `:footer-section-item|document section item:Accessibility statement`, path: `/${APP_ROUTE_NAMES.FOOTER_ACCESSIBILITY_STATEMENT}` },
      ]
    },
    {
      section: $localize `:footer-section|useful section title:Useful`,
      links: [
        { title: $localize `:footer-section-item|useful section item:FAQ`, path: `/${APP_ROUTE_NAMES.FOOTER_FAQ}` },
        { title: $localize `:footer-section-item|useful section item:Privacy policy`, path: `/${APP_ROUTE_NAMES.FOOTER_PRIVACY_POLICY}` },
        { title: $localize `:footer-section-item|useful section item:Cookies policy`, path: `/${APP_ROUTE_NAMES.FOOTER_COOKIES_POLICY}` },
      ]
    },
  ]
}
